/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MediaSourceQualityIssue } from './MediaSourceQualityIssue';
import {
    MediaSourceQualityIssueFromJSON,
    MediaSourceQualityIssueFromJSONTyped,
    MediaSourceQualityIssueToJSON,
    MediaSourceQualityIssueToJSONTyped,
} from './MediaSourceQualityIssue';

/**
 * Quality of canonical media-source selection, independent from publication and purchase-cost quality.
 * @export
 * @interface MediaSourceQuality
 */
export interface MediaSourceQuality {
    /**
     * 
     * @type {number}
     * @memberof MediaSourceQuality
     */
    version?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MediaSourceQuality
     */
    applicable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaSourceQuality
     */
    available?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaSourceQuality
     */
    complete?: boolean;
    /**
     * 
     * @type {Array<MediaSourceQualityIssue>}
     * @memberof MediaSourceQuality
     */
    issues?: Array<MediaSourceQualityIssue>;
}

/**
 * Check if a given object implements the MediaSourceQuality interface.
 */
export function instanceOfMediaSourceQuality(value: object): value is MediaSourceQuality {
    return true;
}

export function MediaSourceQualityFromJSON(json: any): MediaSourceQuality {
    return MediaSourceQualityFromJSONTyped(json, false);
}

export function MediaSourceQualityFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaSourceQuality {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'] == null ? undefined : json['version'],
        'applicable': json['applicable'] == null ? undefined : json['applicable'],
        'available': json['available'] == null ? undefined : json['available'],
        'complete': json['complete'] == null ? undefined : json['complete'],
        'issues': json['issues'] == null ? undefined : ((json['issues'] as Array<any>).map(MediaSourceQualityIssueFromJSON)),
    };
}

export function MediaSourceQualityToJSON(json: any): MediaSourceQuality {
    return MediaSourceQualityToJSONTyped(json, false);
}

export function MediaSourceQualityToJSONTyped(value?: MediaSourceQuality | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
        'applicable': value['applicable'],
        'available': value['available'],
        'complete': value['complete'],
        'issues': value['issues'] == null ? undefined : ((value['issues'] as Array<any>).map(MediaSourceQualityIssueToJSON)),
    };
}

